import {
    clickEvent,
    customDocumentEvent,
    customEvent,
    documentLoadEvent,
    fireInputEvent
} from "../../../webpack/modules/events";
import {
    closeLoader,
    closeResults, hideCloseButton, openLoader,
    renderFullView,
    renderProducts, showCloseButton,
    updateQueryParameter
} from "../../../webpack/modules-optimized/searcher-v2";
import {isDesktop} from "../../../webpack/modules/devices";
import {hideOffcanvas} from "../../../webpack/modules-optimized/offcanvas";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";

documentLoadEvent(function() {
    let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
    let input = container.querySelector('.search-form input');

    const params = new URLSearchParams(window.location.search);
    const searchTerm = params.get('search');
    if (searchTerm) {
        input.value = searchTerm;
    }
    if (input.value !== '') fireInputEvent(input, false);
});

clickEvent('.searcher-results input.filter', true, function(filter) {
    let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
    let search = container.querySelector('.search-form input');
    let parentFilter = container.querySelector(`input.filter[value="${filter.dataset.parent}"]`);
    let childFilters = container.querySelectorAll(`#filter-${filter.dataset.name.toLowerCase().replaceAll(' ', '')}-children input.filter`);

    if (parentFilter) parentFilter.checked = false;
    if (childFilters) childFilters.forEach((childFilter) => childFilter.checked = false);

    let filters = Array.from(container.querySelectorAll('input.filter:checked')).map((filter) => filter.value);

    if (search.value && search.value.length) {
        openLoader();
        renderFullView(search.value, filters);
        if (!isDesktop()) hideOffcanvas('searcher-results-mobile-filters');
        closeLoader();
        ga4TrackSimpleEvent({
            'event': 'search_results',
            'method': filter.checked ? 'select' : 'unselect',
            'content_type': filter.dataset.name
        });
    }
});

clickEvent('.searcher-results .load-more-results', true, async function(button) {
    let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
    let buttonContainer = button.closest('.load-more-results-container');
    let loader = container.querySelector('.searcher-results .loader-more-results');
    let search = container.querySelector('.search-form input');
    let nextPage = button.dataset.nextPage;
    let pageToken = button.dataset.pageToken;
    let filters = Array.from(container.querySelectorAll('input.filter:checked')).map((filter) => filter.value);

    button.remove();
    loader.classList.remove('d-none');
    if (search.value && search.value.length) {
        await renderProducts(search.value, filters, nextPage, pageToken);
    }
    buttonContainer.remove();
});

clickEvent('.close-searcher-results', false, function() {
    let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
    let input = container.querySelector('.search-form input');
    let resultsContainer = container.querySelector('.searcher-results');

    input.value = '';
    updateQueryParameter('');
    resultsContainer.innerHTML = '';
    closeResults();
});

clickEvent('.searcher-results .btn-clear-filters', true, function() {
    let container = isDesktop() ? document.querySelector('.desktop .header-searcher') : document.querySelector('.mobile .header-searcher')
    let search = container.querySelector('.search-form input');

    container.querySelectorAll('input.filter:checked').forEach((filter) => filter.checked = false);

    if (search.value && search.value.length) {
        openLoader();
        renderFullView(search.value, []);
        hideOffcanvas('searcher-results-mobile-filters');
        closeLoader();
        ga4TrackSimpleEvent({
            'event': 'filter_search_results',
            'method': 'delete_filter',
            'content_type': 'all'
        });
    }
});

clickEvent('.searcher-results .empty-results-banner a[href^="mailto"]', true, function() {
    ga4TrackSimpleEvent({'event': 'noresult_page', 'method': 'contact'});
})

clickEvent('.searcher-results .recommender a', true, function(element) {
    ga4TrackSimpleEvent({
        'event': 'noresult_page',
        'method': element.dataset.analyticsMethod,
        'content_type': element.dataset.analyticsName
    });
});

clickEvent('.searcher-results .recommender-container .embla-direction-button', true, function(element) {
    ga4TrackSimpleEvent({
        'event': 'noresult_page',
        'method': element.dataset.analyticsMethod,
        'content_type': 'see_more'
    });
});

customEvent('show.bs.offcanvas', '#searcher-results-mobile-filters', true, hideCloseButton);
customEvent('hidden.bs.offcanvas', '#searcher-results-mobile-filters', true, showCloseButton);